import React from 'react';
import { NavigationDots } from '../components';

const AppWrap = (Component, idName, classNames) => function HOC() {
  return (
    <div id={idName} className={`app__container ${classNames}`}>

{/* //add a social media self closing div back in here and 
import it to add social media jsx back into wrap */}

      <div className="app__wrapper app__flex">
        <Component />

        <div className="copyright">
          <p className="p-text">2022 AB</p>
          <p className="p-text">this is a work in progress</p>
        </div>
      </div>
      <NavigationDots active={idName} />
    </div>
  );
};

export default AppWrap;